import React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Unstable_Grid2";
import LensSharpIcon from "@mui/icons-material/LensSharp";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { Divider } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";

const CssParentBox = styled(Box)({
  position: "fixed",
  border: "1px solid #fff",
  background: "#303030",
  zIndex: "1000",
  width: "200px",
  height: "230px",
  top: 150,
  right: 0,
  overflow: "hidden",
});

const CssBox = styled(Grid)({
  maxWidth: "200px",
  display: "flex",
  backgroundColor: "#303234",
  borderWidth: "1px",
  borderColor: "white",
});

const CssPaper = styled(Paper)({
  display: "flex",
  flexDirection: "row",
  paddingBottom: "4px",
  backgroundColor: "#303234",
});

const CssTypography = styled(Typography)({
  color: "white",
  fontSize: "14px",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  padding: "5px",
  color: "white", // Change the checked color (blue)
  backgroundColor: "transparent",
  borderColor: "white",
  "& .MuiSvgIcon-root": {
    fontSize: 16,
    color: "white",
  },
  "&.Mui-checked": {
    color: "white", // Change the checked color (blue)
    backgroundColor: "transparent",
  },
}));

export default function DataNetworkUsageGuide(props) {
  const { visibleEdgeTypes, setVisibleEdgeTypes, setCount } = props;

  const handleCheckboxChange = (checkboxName) => (event) => {
    setVisibleEdgeTypes({
      ...visibleEdgeTypes,
      [checkboxName]: event.target.checked ? event.target.value : "",
    });
    setCount("push");
  };
  return (
    <CssParentBox sx={{ flexDirection: "row-reverse" }}>
      <CssBox sx={{ flexDirection: "row" }}>
        <Grid xs={6} md={6} style={{ color: "white" }}>
          <CssTypography
            style={{
              whiteSpace: "nowrap",
              marginRight: "8px",
              marginTop: "3px",
            }}
          >
            【凡例】
          </CssTypography>
        </Grid>
        <Grid xs={6} md={6}>
          <CssPaper elevation={0}>
            <LensSharpIcon style={{ color: "#007CB0" }} />
            <CssTypography style={{ paddingTop: "3px", paddingLeft: "10px" }}>
              探索データ
            </CssTypography>
          </CssPaper>
          <CssPaper elevation={0}>
            <LensSharpIcon style={{ color: "#43B02A" }} />
            <CssTypography style={{ paddingTop: "3px", paddingLeft: "10px" }}>
              実データ有
            </CssTypography>
          </CssPaper>
          <CssPaper elevation={0}>
            <LensSharpIcon style={{ color: "#63666A" }} />
            <CssTypography style={{ paddingTop: "3px", paddingLeft: "10px" }}>
              実データ無
            </CssTypography>
          </CssPaper>
        </Grid>
      </CssBox>
      <CssBox sx={{ flexDirection: "row" }}>
        <Grid
          xs={5}
          md={5}
          style={{
            width: "10%",
            paddingTop: "12px",
            paddingLeft: "5px",
            fontFamily: "Meiryo, -apple-system",
          }}
        >
          <StyledCheckbox
            checked={visibleEdgeTypes.checkbox5 !== ""}
            onChange={handleCheckboxChange("checkbox5")}
            value="type5"
            inputProps={{ "aria-label": "type5" }}
          />
          <StyledCheckbox
            checked={visibleEdgeTypes.checkbox4 !== ""}
            onChange={handleCheckboxChange("checkbox4")}
            value="type4"
            inputProps={{ "aria-label": "type4" }}
          />
          <StyledCheckbox
            checked={visibleEdgeTypes.checkbox3 !== ""}
            onChange={handleCheckboxChange("checkbox3")}
            value="type3"
            inputProps={{ "aria-label": "type3" }}
          />
          <StyledCheckbox
            checked={visibleEdgeTypes.checkbox2 !== ""}
            onChange={handleCheckboxChange("checkbox2")}
            value="type2"
            inputProps={{ "aria-label": "type2" }}
          />
          <StyledCheckbox
            checked={visibleEdgeTypes.checkbox1 !== ""}
            onChange={handleCheckboxChange("checkbox1")}
            value="type1"
            inputProps={{ "aria-label": "type1" }}
          />
        </Grid>
        <Grid
          xs={5}
          md={5}
          style={{ color: "white", width: "45%", padding: "10px" }}
        >
          <CssTypography
            style={{
              whiteSpace: "nowrap",
              marginRight: "8px",
              marginTop: "5px",
              color: visibleEdgeTypes.checkbox5 !== "" ? "white" : "#999",
            }}
          >
            類似度：1
          </CssTypography>
          <CssTypography
            style={{
              whiteSpace: "nowrap",
              marginRight: "8px",
              marginTop: "5px",
              color: visibleEdgeTypes.checkbox4 !== "" ? "white" : "#999",
            }}
          >
            類似度：0.8
          </CssTypography>
          <CssTypography
            style={{
              whiteSpace: "nowrap",
              marginRight: "8px",
              marginTop: "5px",
              color: visibleEdgeTypes.checkbox3 !== "" ? "white" : "#999",
            }}
          >
            類似度：0.6
          </CssTypography>
          <CssTypography
            style={{
              whiteSpace: "nowrap",
              marginRight: "8px",
              marginTop: "5px",
              color: visibleEdgeTypes.checkbox2 !== "" ? "white" : "#999",
            }}
          >
            類似度：0.4
          </CssTypography>
          <CssTypography
            style={{
              whiteSpace: "nowrap",
              marginRight: "8px",
              marginTop: "5px",
              color: visibleEdgeTypes.checkbox1 !== "" ? "white" : "#999",
            }}
          >
            類似度：0.2
          </CssTypography>
        </Grid>

        <Grid xs={5} md={5} style={{ width: "45%", paddingLeft: "4px" }}>
          <Divider
            style={{
              backgroundColor:
                visibleEdgeTypes.checkbox5 !== "" ? "#DA291C" : "#DA291C80",
              marginTop: "23px",
              height: "3.5px",
            }}
          />
          <Divider
            style={{
              backgroundColor:
                visibleEdgeTypes.checkbox4 !== "" ? "#FFAA00" : "#FFAA0080",
              marginTop: "23px",
              height: "3px",
            }}
          />
          <Divider
            style={{
              backgroundColor:
                visibleEdgeTypes.checkbox3 !== "" ? "#FFFF2D" : "#FFFF2D80",
              marginTop: "23px",
              height: "1.5px",
            }}
          />
          <Divider
            style={{
              backgroundColor:
                visibleEdgeTypes.checkbox2 !== "" ? "#BBBCBC" : "#BBBCBC80",
              marginTop: "23px",
              height: "1px",
            }}
          />
          <Divider
            style={{
              backgroundColor:
                visibleEdgeTypes.checkbox1 !== "" ? "#63666A" : "#63666A80",
              marginTop: "23px",
              height: "0.5px",
            }}
          />
        </Grid>
      </CssBox>
    </CssParentBox>
  );
}
